var CurrentUser = require("lib/account/CurrentUser");
var TierRequirementsDisplay = require("components/games/TierRequirementsDisplay");
var Tiers = require("lib/games/Tiers");

require("games/trophy_room.scss");

class TrophyRoom extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			ownedPatches: [], ownedPerks: [], ownedFurnitures: []
		};
	}

	render() {
		var tierRows = _.map(Tiers.REQUIREMENTS, function(tierReqs, currentTier) {
			var tierIconPath = Tiers.getIcon(currentTier);
			var rowBackgroundPath = require("tiers/trophy-shelf-" + currentTier.toString() + ".png");
			var tierReqDisplay = (
				<TierRequirementsDisplay requirements={ tierReqs } tier={ currentTier }
					ownedPatches={ this.state.ownedPatches } ownedPerks={ this.state.ownedPerks } 
					ownedFurnitures={ this.state.ownedFurnitures } maxSquares={ 8 } displayAllItems={ true } />
			);

			return (
				<div className="row tierRow" key={ "tier" + currentTier } >
					<img src={ rowBackgroundPath } className="shelfBackground"/>
					<div className="col-sm-1">
						<img src={ tierIconPath } className="tierIcon" />
					</div>
					<div className="col-sm-11">
						{ tierReqDisplay }
					</div>
				</div>
			);
		}.bind(this));

        var student = this.props.student

        if (student.perks.houses != "") {
			var backgroundPath = require("perks/houses/" +
				student.perks.houses
					.toLowerCase()
					.replace(/ /g, "-")
					.replace("'", "") +
				"-empty.png");
		}

		//var backgroundPath = require("perks/houses/trophy-room-empty.png");

		return (
			<div className="trophyRoom">
				<img src={ backgroundPath } className="modalBackground"/>
				<div className="row trophyShelf">
					<div className="col-sm-1">
					</div>
					<div className="col-sm-10">
						{ tierRows }
					</div>
					<div className="col-sm-1">
					</div>
				</div>
			</div>
		);
	}

	componentDidMount() {
        var studentID = this.props.student.id
		CurrentUser.api().getPatches({ user_id: studentID }, $wr.apiHandler(function(response) {
			var filteredPatches = _.select(response.patches, function(patch) {
				return patch.owned && patch.source == "store";
			});
			this.setState({ ownedPatches: filteredPatches });
		}.bind(this)));
		CurrentUser.api().getPerks({ user_id: studentID }, $wr.apiHandler(function(response) {
			var filteredPerks = _.select(response.perks, function(perk) {
				return perk.owned && perk.source == "store";
			});
			this.setState({ ownedPerks: filteredPerks });
		}.bind(this)));
		CurrentUser.api().getPerks({furniture_only: true, user_id: studentID }, $wr.apiHandler(function(response) {
			var filteredFurnitures = _.select(response.perks, function(perk) {
				return perk.owned && perk.source == "store";
			});
			this.setState({ ownedFurnitures: filteredFurnitures });
		}.bind(this)));
	}
};

TrophyRoom.propTypes = StrictPropTypes({
	// Subject student's ID
	student: PropTypes.object.isRequired,
});

module.exports = TrophyRoom;


// WEBPACK FOOTER //
// ./modules/components/games/TrophyRoom.js